export const MODULE_GROUP_TABS = [
    { id: 'kindergarten', label: 'ЗДО' },
    { id: 'school', label: 'Школи' },
];

export const moduleGroupLabel = {
    kindergarten: 'ЗДО',
    school: 'Школи',
    common: 'Загальні',
};

export function partitionMenuByGroup(menu) {
    const grouped = { kindergarten: [], school: [], common: [] };
    if (!Array.isArray(menu)) return grouped;
    for (const item of menu) {
        if (item?.module_group === 'school') grouped.school.push(item);
        else if (item?.module_group === 'kindergarten') grouped.kindergarten.push(item);
        else grouped.common.push(item);
    }
    return grouped;
}
